import { Outlet, useLoaderData } from "react-router";
import { serverCallApiCMS } from "~/services/serverCallAPI";
import { Route } from "../+types/_layout";
import { IPage } from "~/types/types";
import {
  buildCanonicalLink,
  buildMetaFromLoader,
  buildSeoMeta,
  getOrigin,
} from "~/utils/seo";
import { hostName } from "~/utils/format";
import { StructuredDataScript } from "~/components/structured-data-script";

export async function loader({ request }: Route.LoaderArgs) {
  const contentPage = await serverCallApiCMS<IPage>(
    "/api/v1/web/pages/tuyen-dung"
  ).catch(() => {
    return {
      slug: "",
      description: "",
      content: "",
      seo: {
        title: "Tuyển dụng",
        meta_description: "",
        focus_keyphrase: "",
        og_image: [],
      },
      structured: null,
      structuredData: null,
    };
  });

  const origin = getOrigin(request);
  const url = new URL(request.url);
  const canonical = origin ? `${origin}${url.pathname}` : url.pathname;

  return {
    seo: {
      canonical,
      ...contentPage.seo,
    },
    structuredData: contentPage.structuredData ?? null,
  };
}

export const handle = {
  dynamicLinks: (props: any) => {
    return buildCanonicalLink(props?.data?.seo?.canonical || "");
  },
};
export const meta = (args: Route.MetaArgs) => {
  return buildMetaFromLoader(
    args,
    {
      hostName,
      buildSeoMeta,
    },
    (ld) => ld
  );
};

function Layout() {
  const { structuredData } = useLoaderData<typeof loader>();
  return (
    <>
      <StructuredDataScript data={structuredData} />
      <Outlet />
    </>
  );
}

export default Layout;
